(function () {
  "use strict";

  function start() {
    var root = document.getElementById("queed-ai-lab");
    if (!root) return;

    var brand = root.querySelector("#q-brand");
    var model = root.querySelector("#q-model");

    if (!brand || !model) return;

    function getDatabase() {
      try {
        if (typeof QUEED_PHONE_MODELS !== "undefined") {
          return QUEED_PHONE_MODELS;
        }
      } catch (e) {}

      if (window.QUEED_PHONE_MODELS) {
        return window.QUEED_PHONE_MODELS;
      }

      return {};
    }

    function populateModels() {
      var db = getDatabase();
      var selectedBrand = String(brand.value || "").trim();

      model.innerHTML =
        '<option value="">Select model</option>';

      if (
        !selectedBrand ||
        !Array.isArray(db[selectedBrand])
      ) {
        model.disabled = true;
        model.setAttribute("disabled", "disabled");
        return;
      }

      db[selectedBrand].forEach(function (name) {
        var option = document.createElement("option");

        option.value = name;
        option.textContent = name;

        model.appendChild(option);
      });

      model.disabled = false;
      model.removeAttribute("disabled");

      console.log(
        "QUEED models loaded:",
        selectedBrand,
        db[selectedBrand].length
      );
    }

    brand.addEventListener("change", function () {
      setTimeout(populateModels, 10);
    });

    model.addEventListener("change", function () {
      if (
        window.QUEED_MODEL_ENGINE &&
        typeof window.QUEED_MODEL_ENGINE.applyAI === "function"
      ) {
        window.QUEED_MODEL_ENGINE.applyAI(root);
      }
    });

    if (brand.value) {
      populateModels();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      { once: true }
    );
  } else {
    start();
  }

  document.addEventListener(
    "shopify:section:load",
    function () {
      setTimeout(start, 100);
    }
  );
})();